import { useContext, useEffect } from "react";

import { Button } from "@material-ui/core";
import { withUbdAnalyticsStep } from "@aspirasi/react-data-analytics";

import { useThemeStyles } from "../../../styles/themes";

import { StoreContext } from "../../../store/context";

import clevertapWebview from "../../../utils/clevertap";
import TrackingUtil from "../../../utils/tracking";

import { EVENT_NAME } from "../../../constants/clevertap";
import { NC_EVT } from "../../../constants/tracking";

import Header from "../../../components/Header";
import Footer from "../../../components/Footer";

import "./ConsentConfirmed.scss";

const ConsentConfirmed = () => {
  const classes = useThemeStyles();
  const { state, actions } = useContext(StoreContext);

  // TODO: i18n
  const lang = "en";

  const contentKey = state.isOnboardingUpdate ? "completedUpdateApplicationPage" : "completedApplicationPage";

  const content = {
    title: `${state.prerequisites?.journeyConfigurations?.[contentKey]?.title?.[lang]}!`,
    message: state.prerequisites?.journeyConfigurations?.[contentKey]?.messageBody?.[lang]
  };

  const makePayment = () => {
    if (state.pToken) {
      actions.startTransaction();
    }
  };

  const redirectDashboard = (type) => {
    if (type === "new") {
      actions.getDashboardUrl().then((res) => {
        if (res.data?.redirectionUrl) {
          window.location.href = res.data?.redirectionUrl;
        }
      });
      return;
    }

    if (state.dashboardUrl) {
      window.location.href = state.dashboardUrl;
    } else {
      window.location.href = process.env.REACT_APP_BNPL_DASHBOARD_URL;
    }
  };

  // useEffect(() => {
  //   if (state.embedded) {
  //   // Fetch dashboard URL
  //     actions.getDashboardUrl();
  //   }
  // }, []);

  useEffect(() => {
    clevertapWebview.pushEvent(EVENT_NAME.OUTCOME_BNPL_REG_SUCCESS, { SOURCE: "main" });
    TrackingUtil.sendNetcoreEventHelper(NC_EVT.OUTCOME_REG_SUCCESS, { source: "main" });
  }, []);

  return (
    state.prerequisites
    && (
      <>
        <Header />
        <div className="page page-consent-confirmed ">
          <div
            className={`${classes.content} ${classes.customScrollbar} content custom-scrollbar`}
            style={{ display: "flex", flexDirection: "column" }}
          >
            <div style={{ flex: 1, display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
              <img
                className="banner"
                src="/images/success-tick.png"
                alt="success"
              />
              <p className="congrats-title">
                {content.title}
              </p>
              <p
                className="congrats-sub-title"
                dangerouslySetInnerHTML={{
                  __html: content.message
                }}
              />
            </div>

            <div className="action-holder" style={{ display: "flex", flexDirection: "column", gap: "10px", }}>
              {state.pToken && (
                <Button className={`${classes.btnContained} btn-next`} variant="contained" color="primary" onClick={makePayment}>
                  Make Payment
                </Button>
              )}

              {state.isOnboardingUpdate && (
                <Button className={`${classes.btnContained} btn-next`} variant="contained" color="primary" onClick={() => redirectDashboard("new")}>
                  Done
                </Button>
              )}

              {!state.pToken && !state.embedded && (
                <Button className={`${classes.btnContained} btn-next`} variant="contained" color="primary" onClick={redirectDashboard}>
                  Go to PayFlex Dashboard
                </Button>
              )}
            </div>
          </div>
          <Footer />
        </div>
      </>
    )
  );
};

export default withUbdAnalyticsStep(ConsentConfirmed, {
  stepId: "ConsentConfirmed",
  endJourneyOnStepStart: true,
});
